import React, { useState } from "react";
import "./Login.css";
import { Form, Input, Button, Flex, message } from "antd";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Password } from "../../assets/pass.svg";
import { resetPassword } from "../../services/ApiService";
import CryptoJS from "crypto-js";
import { LoadingOutlined } from "@ant-design/icons";

const ReSetPassword = () => {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [isPassComplete, setIsPassComplete] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      setLoader(true);
      const hash = CryptoJS.SHA256(values?.password).toString();
      const obj = {
        email: sessionStorage.getItem("email"),
        new_password: hash,
      };
      const res = await resetPassword(obj);
      if (res.responseCode === 200) {
        await message.success(res.responseMessage);
        navigate("/login");
      } else {
        message.error(res.responseMessage);
      }
    } catch (error) {
      message.error("An error occurred. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  const validatePassword = (_, value) => {
    if (!value) {
      setIsPassComplete(false);
      return Promise.reject(new Error("Please enter a new password!"));
    }
    const passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (!passwordPattern.test(value)) {
      setIsPassComplete(false);
      return Promise.reject(
        new Error(
          "Password must be at least 8 characters long, and include at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 symbol."
        )
      );
    }

    return Promise.resolve();
  };

  const handlePassword = () => {
    form
      .validateFields()
      .then(onFinish)
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  return (
    <>
      <div className="main-container">
        <div>
          <Form
            form={form}
            name="login"
            initialValues={{ remember: true }}
            layout="vertical"
            style={{ marginTop: "1.3rem" }}
            onFinish={handlePassword}
          >
            <div className="login">
              <h4 className="title">Reset Password</h4>
              <div className="desc">
                Create a Strong Password: (at least 8 characters with a mix of
                uppercase and lowercase letters, numbers, and symbols)
              </div>
              <Form.Item
                name="password"
                label={<span className="input-label">Enter New Password</span>}
                rules={[
                  { validator: validatePassword },
                  { required: true, message: "Please create new password!" },
                ]}
                colon={false}
              >
                <Input.Password
                  prefix={<Password style={{ marginRight: "8px" }} />}
                  placeholder="Enter New Password"
                  className="input"
                />
              </Form.Item>

              <Form.Item
                name="confirm-password"
                label={
                  <span className="input-label">Confirm New Password</span>
                }
                rules={[
                  {
                    required: true,
                    message: "Please confirm the new password!",
                  },
                  {
                    validator: (_, value) => {
                      const password = form.getFieldValue("password");
                      if (value && value !== password) {
                        setIsPassComplete(false);
                        return Promise.reject(
                          new Error("Passwords do not match!")
                        );
                      }
                      setIsPassComplete(true);
                      return Promise.resolve();
                    },
                  },
                ]}
                colon={false}
              >
                <Input.Password
                  prefix={<Password style={{ marginRight: "8px" }} />}
                  placeholder="Confirm New Password"
                  className="input"
                />
              </Form.Item>
            </div>
            <Flex justify="flex-end" className="login-btn">
              <Button
                type="primary"
                htmlType="submit"
                shape="round"
                disabled={!isPassComplete || loader}
                style={{
                  padding: "1.2rem",
                  backgroundColor: "#4A3AFF",
                }}
              >
                Reset Password
                {loader && <LoadingOutlined style={{ color: "white" }} />}
              </Button>
            </Flex>
          </Form>
        </div>
        <div className="copyright">
          Copyright © 2026 Procloz Services Pvt Ltd | All Rights Reserved
        </div>
      </div>
    </>
  );
};

export default ReSetPassword;
